var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "breadcrumbs" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "ul",
        { staticClass: "breadcrumbs__container" },
        [
          _c(
            "li",
            [
              _c("router-link", { attrs: { to: { name: "home" } } }, [
                _c("span", [_vm._v("Главная")]),
                _c(
                  "pre",
                  [
                    _vm._v(" "),
                    _c("IconComponent", { attrs: { name: "arrow-right" } }),
                    _vm._v("  "),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._l(_vm.links, function (link, i) {
            return _c(
              "li",
              { key: i },
              [
                link.route
                  ? _c("router-link", { attrs: { to: link.route } }, [
                      _c("span", [_vm._v(_vm._s(link.title))]),
                      _c(
                        "pre",
                        [
                          _vm._v(" "),
                          _c("IconComponent", {
                            attrs: { name: "arrow-right" },
                          }),
                          _vm._v(" "),
                        ],
                        1
                      ),
                    ])
                  : _c("span", [_vm._v(_vm._s(link.title))]),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }